"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = Drawer;
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Drawer_1 = __importDefault(require("@material-ui/core/Drawer"));
const Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
const variables_1 = __importDefault(require("../../styles/variables"));
const clsx_1 = __importDefault(require("clsx"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const Icon_1 = require("../Icon");
const DrawerWidth = {
    desktop: {
        opened: '250px',
        closed: '64px',
    },
    mobile: {
        opened: '100%',
        closed: '0px',
    },
};
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    drawer: {
        flexShrink: 0,
        transition: 'width 500ms',
        width: (props) => props.drawerOpen
            ? DrawerWidth.desktop.opened
            : DrawerWidth.desktop.closed,
        [theme.breakpoints.down('sm')]: {
            width: (props) => props.drawerOpen
                ? DrawerWidth.mobile.opened
                : DrawerWidth.mobile.closed,
        },
    },
    drawerContainer: {
        overflowX: 'hidden',
        overflowY: 'scroll',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        height: '100%',
        transition: 'width 500ms',
    },
    drawerPaper: {
        transition: 'width 500ms',
        width: (props) => props.drawerOpen
            ? DrawerWidth.desktop.opened
            : DrawerWidth.desktop.closed,
        [theme.breakpoints.down('xs')]: {
            width: (props) => props.drawerOpen
                ? DrawerWidth.mobile.opened
                : DrawerWidth.mobile.closed,
        },
    },
    drawerMobileClose: {
        marginBottom: '24px',
        margin: '18px',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    drawerMobileCloseIcon: {
        fontSize: '18px',
    },
    menuButton: {
        color: variables_1.default.colors.text.subdued,
        transition: 'transform 500ms',
        margin: '16px',
        alignSelf: 'flex-end',
        transform: (props) => props.drawerOpen ? 'rotate(-180deg)' : 'rotate(0)',
    },
    drawerMenu: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },
    divider: {
        marginBottom: '1rem',
        width: '100%',
    },
}));
function Drawer({ drawerOpen, className, drawerContent, onToggleDrawer, }) {
    const classes = useStyles({ drawerOpen: drawerOpen });
    return (react_1.default.createElement(Drawer_1.default, { className: (0, clsx_1.default)([classes.drawer, className]), variant: "permanent", classes: {
            paper: classes.drawerPaper,
        } },
        react_1.default.createElement(Drawer.Context.Provider, { value: { isOpen: drawerOpen } },
            react_1.default.createElement(Toolbar_1.default, null),
            react_1.default.createElement("div", { className: (0, clsx_1.default)([classes.drawerContainer]) },
                react_1.default.createElement("div", { className: (0, clsx_1.default)() }, drawerContent),
                react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.drawerMenu) },
                    react_1.default.createElement(Divider_1.default, { className: (0, clsx_1.default)(classes.divider) }),
                    react_1.default.createElement(IconButton_1.default, { size: "small", color: "inherit", "aria-label": "open drawer", onClick: onToggleDrawer, className: (0, clsx_1.default)(classes.menuButton), "data-testid": "drawerIcon" },
                        react_1.default.createElement(Icon_1.OutlinedIcon, { icon: "keyboard_double_arrow_right" })))))));
}
Drawer.Context = (0, react_1.createContext)({
    isOpen: false,
});
